import React, { useState } from "react";
import { useSelector } from "react-redux";
import { useNavigate } from "react-router-dom";
import { PERMISSIONS, TENANT_PERMISSIONS } from "../Login/constants";
import usePermission, {
  useTenantPermission,
} from "../../Core/hooks/usePermission";
import { LOCATION_TYPE } from "../Location/Data";
import CloseIcon from "../../Common/Svgs/CloseIcon";
import FilterItem from "../../Core/Components/FilterItem";
import PlusIcon from "../../Common/Svgs/PlusIcon";
import CustomInput from "../../Core/Components/CustomInput";

const Header = ({ search, setSearch, filters, setFilters, setCurrentPage }) => {
  const navigate = useNavigate();

  const { allLocations } = useSelector((state) => state.locations);

  // tenant level permission
  const hasTenantLocationPermission = useTenantPermission([
    TENANT_PERMISSIONS.LOCATION_MODULE_ACCESS,
  ]);

  // user level permission
  const hasAddPermission = usePermission([PERMISSIONS.CHARGER_ADD]);

  const hubStations = allLocations
    .filter((item) => item.type === LOCATION_TYPE.HUB_STATION)
    .map((location) => ({
      id: location.id,
      value: location.name,
    }));

  const [focus, setFocus] = useState(false);

  const onSelect = (key, value) => {
    // whenever applying the filter, the page should be defaulted back to first page
    setCurrentPage(1);

    if (filters[key].includes(value)) {
      const newFilters = filters[key].filter((item) => item !== value);
      setFilters({ ...filters, [key]: newFilters });
    } else {
      setFilters({ ...filters, [key]: [...filters[key], value] });
    }
  };

  return (
    <div className="bg-background-white">
      <div className="px-6 py-3.5 flex items-center justify-between">
        <div className="flex items-center gap-x-3">
          <CustomInput
            intent="search"
            prefix={
              <img src="/assets/icons/search.svg" alt="" className="mr-2" />
            }
            value={search}
            focus={focus}
            border={focus ? "success" : "none"}
            placeholder={focus ? null : "Search Container ID"}
            onChange={(e) => {
              setSearch(e.target.value);
              // on search reset the page to 1
              setCurrentPage(1);
            }}
            onFocus={() => setFocus(true)}
            onBlur={() => setFocus(false)}
            suffix={
              search.length > 0 ? (
                <CloseIcon
                  className="w-4 h-4 cursor-pointer stroke-dark-grey-text"
                  onClick={() => {
                    setFocus(false);
                    setSearch("");
                  }}
                />
              ) : null
            }
          />

          {hasTenantLocationPermission && (
            <FilterItem
              label="Hub Station"
              identifier="hub"
              contentData={hubStations}
              onSelect={onSelect}
              selectedValues={filters.hub}
              className="max-h-[200px] overflow-y-scroll"
              enableSearch
            />
          )}
        </div>

        {hasAddPermission && (
          <button
            type="button"
            className="px-4 py-[11px] bg-primary hover:bg-primary-50 rounded-md"
            onClick={() => navigate("/add-container")}
          >
            <div className="flex item-center gap-x-2">
              <PlusIcon className="w-4 h-4 stroke-white" />
              <p className="font-poppins text-xs font-medium text-background-white">
                Add Container
              </p>
            </div>
          </button>
        )}
      </div>
    </div>
  );
};

export default Header;
